export default __webpack_public_path__ + "static/media/tracker.c4c7c7b3.jpg";